import React, { Component } from 'react';
import Aux from './../Wrapper/Auxiliary';
import SimpleReactValidator from 'simple-react-validator';
import moment from '../../Global/Time/Moment';
import Datetime from 'react-datetime';
import "react-datepicker/dist/react-datepicker.css"
import * as actionCreators from "../../Redux/Actions";
import { connect } from "react-redux";
import eventCallRequest from "../../Global/Helper/HelperEvent";
import { conformToMask } from 'react-text-mask';
import { ApiConfig } from "../../config/ApiConfig";
import CryptoJS from 'crypto-js';
import NotificationSystem from "react-notification-system";
import LoadingComponent from "../../common/UI/loadingComponent";
import coupon from '../../assets/img/coupon.png';
import Logo from '../../assets/img/logo.png';
import CarouselItems from './CarouselItems'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { BottomLogo, EXPIRY_MONTHS, EXPIRY_YEARS } from '../../Global/Constant'
import { getPaymentInitials } from '../../Redux/Actions';
import queryString from 'query-string'
import { checkValidations, makePayment } from '../../Redux/Actions/passesAction';
import { getSessionAttribute } from '../../Global/Helper/Helper';
import { isSafari, restrictInputValues, validExpiryDate } from '../../Global/Helper/helpers';
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useRecaptcha from '../../Hooks/useRecaptcha';
const expirymask = createDefaultMaskGenerator('99/99')

class PassComponent extends Component {
    encryptKey = ApiConfig.encryptKey;
    dateMask = [/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/];
    cardMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    security_codeMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    zipmask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    maskGenerator = createDefaultMaskGenerator('9999 9999 9999 9999')
    phoneMaskGenerator = createDefaultMaskGenerator('(999) 9999-9999')
    constructor(props) {
        super(props);
        this.state = {
            userData: '',
            email_address: '',
            name: '',
            card_number: '',
            cvv: '',
            expiry_date: '',
            zip_code: '',
            pass_id: '',
            pass_rate_id: '',
            price: 0,
            processing_fee: 0,
            latitude: '',
            longitude: '',
            length: ApiConfig.defaultBookingLength,
            isMember: true,
            isPassExits: false,
            is_book_parking: true,
            passWithParking: false,
            existPass: {},
            paymentScreenOpen: false,
            entry_date: 'Select Date',
            entry_date_exist : 'Select Date',
            // entry_date: moment().format('MM/DD/yyyy'),
            exit_date: moment().format('MM/DD/yyyy'),
            isSubmitted: false,
            paymentSession: {},
            inputType: 'password',
            eyeIcon: faEye,
            card_pan: '',
            card_card_security_cvx_2: '',
            card_date_expiry_month: '',
            card_date_expiry_year: '',
            isBooking: false,
            expiryTime: 900000,
            bookingType: 'passPurchage',
            expiry: '',
            isSelectPass: false,
            passPrice: '',
            isExistingPassed : false,
            passId : '',
            disableloader : true,
            passcheck : false

        }
        this.formRef = React.createRef();
        // this.paymentWindow = window

        this.validator = new SimpleReactValidator({
            validators: {
                validCard: {
                    message: 'The card number must be between 15 and 16 digits.',
                    rule: (val, params) => {
                        return ((this.state.card_number.replace(/\D/g, '').length < 15) && params.indexOf(val) === -1) ? false : true;
                    },
                    required: true
                },
            }
        });
        this.notificationSystem = React.createRef();
        this.dateTimeDisplayFormat = 'MM/DD/yyyy';
        this.dateDisplayFormat = 'MM/DD/yyyy';
        this.sendDateFormat = 'yyyy-MM-dd';
        this.senddateTimeFormat = 'YYYY-MM-DD';
        this.timeSelection = ApiConfig.timeDropDown;
        this.phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }

    carouselOptions = {
        nav: false,
        rewind: false,
        autoplay: false,
        margin: 30,
        loop: false,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            }
        }
    }

    componentDidMount = () => {
        localStorage.setItem('queries', '{}')
        localStorage.setItem('isBooking', 0)
        localStorage.setItem('passDetails', JSON.stringify({ is_book_parking: true }))
        const userData = localStorage.getItem('userData')
        // this.setState({ isBooking: true })
        this.setState({ isBooking: false })
        let eventParams = eventCallRequest('Pass Screen Loaded', JSON.stringify(userData));


        setTimeout(() => {
            this.setState({ expiryTime: 0 })
        }, 900000)




        this.setState({ paymentScreenOpen: false })

        this.props.eventRequest(eventParams).then(() => { });

        this.setState({ isSubmitted: true }, () => {
            const secret = ApiConfig.clientSecret
            const apiCallLog = { userData, secret }

            let eventParams = eventCallRequest('Partner Details API Call', JSON.stringify(apiCallLog));
            this.props.eventRequest(eventParams).then(() => { });
            this.props.reqGetPartnerDetails(ApiConfig.clientSecret).then(() => {
                const notification = this.notificationSystem.current;
                const { hasErrorPartner, partnerDetails, hasErrorMessage } = this.props;
                // localStorage.setItem('proFee', partnerDetails.facilities[0].processing_fee)
                localStorage.setItem('proFee', this.props.getGaragePriceRes?.processing_fee)
                let apiFailLog = { userData, hasErrorPartner }
                apiFailLog = { ...apiFailLog, secret }
                if (hasErrorPartner) {
                    let eventParams = eventCallRequest('Partner Details API Failed', JSON.stringify(apiFailLog));
                    this.props.eventRequest(eventParams).then(() => { });

                    notification.addNotification({
                        title: 'Sorry!',
                        message: hasErrorMessage,
                        level: 'error'
                    });
                } else {
                    let apiSuccessLog = { userData, partnerDetails }
                    apiSuccessLog = { ...apiSuccessLog, secret }
                    let eventParams = eventCallRequest('Partner Details API Success', JSON.stringify(apiSuccessLog), partnerDetails.facilities[0].id);
                    this.props.eventRequest(eventParams).then(() => { });

                    if ((partnerDetails.facilities[0].active == 0) || (partnerDetails.facilities[0].is_available != 1) || (partnerDetails.facilities[0].facility_booking_type == 1)) {
                        notification.addNotification({
                            title: 'Sorry!',
                            message: 'Garage is not available for booking.',
                            level: 'error'
                        });
                        setTimeout(() => {
                            this.props.history.push("/");
                        }, 3000);
                    } else {
                        this.setState({ isSubmitted: false }, () => {
                            let userData = JSON.parse(localStorage.getItem('userData'));
                            if (userData == null) {
                                this.props.history.push("/");
                            } else {
                                this.setState({
                                    userData: userData,
                                    email_address: userData.email,
                                    is_member: userData.is_member,
                                    // processing_fee: (partnerDetails.facilities[0].processing_fee > 0) ? partnerDetails.facilities[0].processing_fee : 0,
                                    processing_fee: (this.props.getGaragePriceRes?.processing_fee > 0) ? this.props.getGaragePriceRes?.processing_fee : 0,
                                    entry_date: this.state.entry_date,
                                }, () => {
                                    localStorage.setItem('entry_date', this.state.entry_date)

                                    if (this.state.is_member) {
                                        this.setState({ isMember: true }, () => {
                                            let reqParams = {
                                                garage_id: this.state.userData.garage_id,
                                                is_member: (this.state.isMember) ? 1 : 0,
                                                arrival: moment(this.state.userData.current_date).format(this.senddateTimeFormat)
                                            }
                                            this.getPassesWithCaptcha(reqParams).then(() => {
                                                const { passes, hasError, errorMessage } = this.props;
                                                const userData = localStorage.getItem('userData')
                                                if (hasError) {
                                                    const apiFailLog = { userData, errorMessage }
                                                    let eventParams = eventCallRequest('Get Passes API Failed', JSON.stringify(apiFailLog));
                                                    this.props.eventRequest(eventParams).then(() => { });
                                                } else {
                                                    const apiSuccessLog = { userData, passes }
                                                    let eventParams = eventCallRequest('Get Passes API Success', JSON.stringify(apiSuccessLog), this.state.userData.garage_id);
                                                    this.props.eventRequest(eventParams).then(() => { });
                                                }
                                            })

                                            this.getUserPassesWithCaptcha({ phone: this.state.userData.phone }).then(() => {
                                                const { userPasses, hasError, errorMessage } = this.props;
                                                const userData = localStorage.getItem('userData')
                                                if (hasError) {
                                                    const apiFailLog = { userData, errorMessage }
                                                    let eventParams = eventCallRequest('Fetch User Passes API Failed', JSON.stringify(apiFailLog));
                                                    this.props.eventRequest(eventParams).then(() => { });
                                                } else {
                                                    const apiSuccessLog = { userData, userPasses }
                                                    let eventParams = eventCallRequest('Fetch User Passes API Success', JSON.stringify(apiSuccessLog), this.state.userData.garage_id);
                                                    this.props.eventRequest(eventParams).then(() => { });
                                                }
                                                this.setState({ isPassExits: userPasses && userPasses.length > 0 ? true : false })

                                            }).then(() => {
                                                let formData = {
                                                    "use_bonus": 0,
                                                    "is_member": (this.state.isMember) ? 1 : 0,
                                                    "length_of_stay": this.state.length,
                                                    "arrival_time": moment(this.state.userData.current_date).format(this.senddateTimeFormat),
                                                    "garage_id": this.state.userData.garage_id
                                                }
                                                this.getGaragePriceWithCaptcha(formData).then(() => {
                                                    const { getGaragePriceRes, hasError, errorMessage } = this.props;
                                                    let userDetails = JSON.parse(localStorage.getItem("userData"))
                                                    userDetails = { ...errorMessage, userDetails }
                                                    if (hasError) {
                                                        let eventParams = eventCallRequest('Fetch Booking Rate API Failed', JSON.stringify(userDetails));
                                                        this.props.eventRequest(eventParams).then(() => { });
                                                    } else {
                                                        userDetails = { ...getGaragePriceRes, userDetails }
                                                        let eventParams = eventCallRequest('Fetch Booking Rate API Success', JSON.stringify(userDetails), this.state.userData.garage_id);
                                                        this.props.eventRequest(eventParams).then(() => { });
                                                    }
                                                    const requestPayload = {
                                                        'amount': getGaragePriceRes?.price,
                                                        'facility_id': userData?.garage_id ? userData?.garage_id : this.props.partnerDetails.facilities[0].id,
                                                        'rate_id': getGaragePriceRes?.id,
                                                        'is_booking_also': 1,
                                                        'arrival': this.state?.entry_date != 'Select Date' ? this.state?.entry_date : moment().format('MM/DD/yyyy') ,
                                                    }
                                                    let userDataLog = localStorage.getItem("userData");
                                                    userDataLog = { ...errorMessage, userDataLog }
                                                    let eventParams = eventCallRequest('IPG Session API Call', JSON.stringify(userDataLog));
                                                    this.props.eventRequest(eventParams).then(() => { });
                                                    this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
                                                        if (res.data && res.data != null) {
                                                            let eventParams = eventCallRequest('IPG Session API Call Success', JSON.stringify(userDataLog));
                                                            this.props.eventRequest(eventParams).then(() => { });
                                                            this.setState({ paymentSession: res?.data, expiryTime: 900000 })
                                                            localStorage.setItem('paymentSession', JSON.stringify(res?.data))
                                                        } else {
                                                            notification.addNotification({
                                                                title: 'Sorry!',
                                                                message: 'There is some Problem with Payment Gateway',
                                                                level: 'error'
                                                            });
                                                            this.setState({ paymentSession: {} })
                                                            localStorage.setItem('paymentSession', JSON.stringify({}))
                                                            let eventParams = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                                            this.props.eventRequest(eventParams).then(() => { });

                                                        }

                                                    }).catch((err) => {
                                                        notification.addNotification({
                                                            title: 'Sorry!',
                                                            message: err,
                                                            level: 'error'
                                                        });
                                                        this.setState({ paymentSession: {} })
                                                        localStorage.setItem('paymentSession', JSON.stringify({}))
                                                        let eventParams = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                                        this.props.eventRequest(eventParams).then(() => { });

                                                    })
                                                    this.setState({ price: (this.state.isPassExits) ? getGaragePriceRes.price : 0, pass_rate_id: '', pass_id: '', is_book_parking: true, length: ApiConfig.defaultBookingLength });
                                                })
                                            })
                                        })
                                    } else {
                                        this.setState({ isSubmitted: false, isMember: false, isPassExits: false }, () => {
                                            let formData = {
                                                "use_bonus": 0,
                                                "is_member": (this.state.isMember) ? 1 : 0,
                                                "length_of_stay": this.state.length,
                                                "arrival_time": moment(this.state.userData.current_date).format(this.senddateTimeFormat),
                                                "garage_id": this.state.userData.garage_id
                                            }
                                            this.getGaragePriceWithCaptcha(formData).then(() => {
                                                const { getGaragePriceRes, hasError, errorMessage } = this.props;
                                                if (hasError) {
                                                    let eventParams = eventCallRequest('Fetch Arrival Rate API Failed', JSON.stringify(errorMessage));
                                                    this.props.eventRequest(eventParams).then(() => { });
                                                } else {
                                                    let eventParams = eventCallRequest('Fetch Arrival Rate API Success', JSON.stringify(getGaragePriceRes), this.state.userData.garage_id);
                                                    this.props.eventRequest(eventParams).then(() => { });

                                                    const requestPayload = {
                                                        'amount': getGaragePriceRes?.price,
                                                        'facility_id': userData?.garage_id ? userData?.garage_id : this.props.partnerDetails.facilities[0].id,
                                                        'rate_id': getGaragePriceRes?.id,
                                                        'is_booking_also': 1,
                                                        'arrival': this.state?.entry_date,
                                                    }
                                                    let userDataLog = localStorage.getItem("userData");
                                                    userDataLog = { ...errorMessage, userDataLog }
                                                    let setUserLog = eventCallRequest('IPG Session API Call', JSON.stringify(userDataLog));
                                                    this.props.eventRequest(setUserLog).then(() => { });
                                                    this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
                                                        if (res.data && res.data != null) {
                                                            let setUserLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(userDataLog));
                                                            this.props.eventRequest(setUserLog).then(() => { });
                                                            this.setState({ paymentSession: res?.data, expiryTime: 900000 })
                                                            localStorage.setItem('paymentSession', JSON.stringify(res?.data))

                                                        } else {
                                                            let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                                            this.props.eventRequest(setUserLog).then(() => { });
                                                            notification.addNotification({
                                                                title: 'Sorry!',
                                                                message: 'There is some problem with Payment Gateway',
                                                                level: 'error'
                                                            });
                                                            this.setState({ paymentSession: {} })
                                                            localStorage.setItem('paymentSession', JSON.stringify({}))
                                                        }
                                                    }).catch((err) => {
                                                        let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                                        this.props.eventRequest(setUserLog).then(() => { });
                                                        notification.addNotification({
                                                            title: 'Sorry!',
                                                            message: err,
                                                            level: 'error'
                                                        });
                                                        this.setState({ paymentSession: {} })
                                                        localStorage.setItem('paymentSession', JSON.stringify({}))
                                                    })

                                                }
                                                this.setState({ price: (getGaragePriceRes && getGaragePriceRes.price ? getGaragePriceRes.price : 0), pass_rate_id: '', pass_id: '', is_book_parking: true, length: ApiConfig.defaultBookingLength });
                                            })
                                        });
                                    }
                                });
                            }
                        })
                    }
                }
            })
        });
    }


    reverseObj = (obj) => {
        let newObj = {}
        Object.keys(obj)
            .reverse()
            .forEach((key) => {
                newObj[key] = obj[key]
            })
        return newObj
    }

    getGaragePriceWithCaptcha = (formData) => {
        return this.props.getRecaptchaToken('get_garage_price').then((captchaToken) =>
            this.props.reqGetPrice({ ...formData, 
                // recaptcha_token: captchaToken 
            })
        );
    }

    getPaymentSessionWithCaptcha = (requestPayload) => {
        return this.props.getRecaptchaToken('session').then((captchaToken) =>
            this.props.dispatch(getPaymentInitials({ ...requestPayload, recaptcha_token: captchaToken }))
        );
    }

    checkValidationsWithCaptcha = (requestPayload) => {
        return this.props.getRecaptchaToken('before_payment').then((captchaToken) =>
            this.props.dispatch(checkValidations({ ...requestPayload, recaptcha_token: captchaToken }))
        );
    }

    makePaymentWithCaptcha = (requestPayload) => {
        return this.props.getRecaptchaToken('booking').then((captchaToken) =>
            this.props.dispatch(makePayment({ ...requestPayload, recaptcha_token: captchaToken }))
        );
    }

    getPassesWithCaptcha = (reqParams) => {
        return this.props.getRecaptchaToken('get_passes').then((captchaToken) =>
            this.props.reqGetPasses({ ...reqParams, 
                // recaptcha_token: captchaToken
             })
        );
    }

    getUserPassesWithCaptcha = (reqParams) => {
        return this.props.getRecaptchaToken('get_user_passes').then((captchaToken) =>
            this.props.reqGetUserPasses({ ...reqParams, 
                // recaptcha_token: captchaToken 
            })
        );
    }

    handleCVVVisibility = (e, type) => {
        if (type === 'text') {
            this.setState({ inputType: 'password', eyeIcon: faEye })

        } else {
            this.setState({ inputType: 'text', eyeIcon: faEyeSlash })
        }
    }


    handleExpiryChange = (value) => {

        let expiryDateCheck = validExpiryDate(value)
        if (value.length === 4 && !expiryDateCheck) {
            // this.setState({ cardExpiryMessage : 'Enter a valid expire date'})
        } else {
            localStorage.setItem('card_date_expiry_month', value.substring(0, 2).trim())
            localStorage.setItem('card_date_expiry_year', value.substring(2).trim())
            this.setState({ card_date_expiry_month: value.substring(0, 2), card_date_expiry_year: value.substring(2), expire: value?.trim() });
        }
    }

    handleFormSubmit = () => {

        const notification = this.notificationSystem.current;
        if (this.state.expiryTime > 0 &&  (this.state.isSelectPass || this.state.entry_date != 'Select Date')) {

            this.setState({ paymentScreenOpen: true });
            const user_Data = JSON.parse(localStorage.getItem('userData'))
            let payNowLog = user_Data;
            const cardLastFour = localStorage.getItem('card_pan')
            const card_date_expiry_month = localStorage.getItem('card_date_expiry_month')
            const card_date_expiry_year = localStorage.getItem('card_date_expiry_year')
            const card_card_security_cvx_2 = localStorage.getItem('card_card_security_cvx_2')

            const paymentDetails = {
                card: cardLastFour,
                expiry_month: card_date_expiry_month,
                expiry_year: card_date_expiry_year,
                cvv: card_card_security_cvx_2
            }
            payNowLog = { ...user_Data, paymentDetails }
            let setUserLog = eventCallRequest('Paynow Button Clicked', JSON.stringify(payNowLog));
            this.props.eventRequest(setUserLog).then((res) => { });
            if (localStorage.getItem('passDetails') === '' && !this.state.isPassExits && this.state.isMember) {
                this.setState({ paymentScreenOpen: false });
                const notification = this.notificationSystem.current;
                notification.addNotification({
                    title: 'Sorry!',
                    message: 'Please select a pass or 1 day parking',
                    level: 'error'
                });
            } else {
                this.setState({ paymentScreenOpen: false });

                const user_Data = JSON.parse(localStorage.getItem('userData'))
                const passDetails = localStorage.getItem('passDetails') ? JSON.parse(localStorage.getItem('passDetails')) : ''
                const paaswithBooking = localStorage.getItem('isBooking')
                const paymentSession = JSON.parse(localStorage.getItem('paymentSession'))


                if (this.state.name != '' && this.state.name != null && this.state.card_pan != '' && this.state.card_pan != null && (this.state.card_pan.length == 15 || this.state.card_pan.length == 16) && this.state.card_card_security_cvx_2 != '' && this.state.card_card_security_cvx_2 != null && (this.state.card_card_security_cvx_2.length == 3 || this.state.card_card_security_cvx_2.length == 4) && this.state.card_date_expiry_month != '' && this.state.card_date_expiry_month != null && this.state.card_date_expiry_year != '' && this.state.card_date_expiry_year != null) {
                    this.setState({ paymentScreenOpen: true });
                    const currentDate = new Date(moment(new Date()).format('YYYY'), moment(new Date()).format('MM') - 1)
                    const cardExpiry = new Date(moment(card_date_expiry_year, 'YY').format('YYYY'), card_date_expiry_month - 1)
                    if (currentDate <= cardExpiry) {

                        const requestPayload = {
                            name: user_Data?.user_name,
                            email: user_Data?.email,
                            phone: user_Data?.phone,
                            "arrival": this.state.entry_date != 'Select Date' ?  this.state.entry_date : moment(new Date()).format('yyyy/MM/DD'),
                            facility_id: user_Data?.garage_id ? user_Data?.garage_id : this.props.partnerDetails.facilities[0].id,
                            mer_reference: paymentSession?.reference,
                            is_pass_purchase: this.state.isPassExits ? 0 : passDetails !== '' ? passDetails?.is_book_parking ? 0 : 1 : 0,
                            is_book_parking: this.state.isPassExits ? 1 : passDetails?.is_book_parking ? 1 : 0,
                            is_booking_also: this.state.isPassExits ? 0 : parseInt(paaswithBooking)
                        }


                        this.checkValidationsWithCaptcha(requestPayload).then((res) => {
                            this.setState({ paymentScreenOpen: true });

                            if (res?.data === "success") {



                                const entry_date = localStorage.getItem('entry_date')
                                const paymentDetails = JSON.parse(localStorage.getItem('paymentSession'))
                                const passDetails = localStorage.getItem('passDetails') ? JSON.parse(localStorage.getItem('passDetails')) : ''
                                const paaswithBooking = localStorage.getItem('isBooking')
                                const requestPayloadMakePayment = {
                                    "length": this.state.length,
                                    "facility_id": user_Data?.garage_id ? user_Data?.garage_id : this.props.partnerDetails.facilities[0].id,
                                    "member_id": user_Data?.member_id,
                                    "pass_id": this.state.pass_id,
                                    "pass_rate_id": passDetails?.is_book_parking ? '' : passDetails?.pass_rate_id,
                                    "is_pass_purchase": this.state.isPassExits ? 0 : passDetails !== '' ? passDetails?.is_book_parking ? 0 : 1 : 0,
                                    "is_booking_also": this.state.isPassExits ? 0 : parseInt(paaswithBooking),
                                    "is_book_parking": this.state.isPassExits ? 1 : passDetails?.is_book_parking ? 1 : 0,
                                    "description": `Reservation for Zoo Atlanta - A beginning at ${moment(this.state.entry_date, this.dateDisplayFormat).format('yyyy-MM-DD')}`,
                                    "total": paymentDetails?.amount,
                                    "session": paymentDetails?.ipgSession,
                                    "email": user_Data?.email,
                                    "phone": user_Data?.phone,
                                    "name": user_Data?.user_name,
                                    "companyName": "",
                                    "is_opt_out": "",
                                    "use_bonus": 0,
                                    "coupon_threshold_price": 0,
                                    "warning_on_reservation": 0,
                                    "warning_on_reservation_msg_email": "",
                                    "is_card_req": 0,
                                    "arrival": this.state.entry_date != 'Select Date' ?  moment(this.state.entry_date, this.dateDisplayFormat).format('yyyy-MM-DD') : moment(new Date()).format('yyyy/MM/DD'),
                                    'MerchantRef': paymentDetails.reference,
                                    'TxID': '',
                                    'AuthorisationCode': '',
                                    'CardType': '',
                                    'TokenNo': '',
                                    'DSIndicator': '',
                                    'SCATransRef': ''

                                }

                                let userDataLog = { ...user_Data, passDetails };
                                userDataLog = { ...userDataLog, requestPayload }
                                let setUserLog = eventCallRequest('Before Booking Data Save API Call', JSON.stringify(userDataLog));
                                this.props.eventRequest(setUserLog).then((res) => { });


                                this.makePaymentWithCaptcha(requestPayloadMakePayment).then((res) => {
                                    this.setState({ paymentScreenOpen: true });

                                    if ((res.data.reservation.id != null) || (res.data.pass.id != null)) {
                                        let responseLog = res.data;

                                        let userDataLog = { ...user_Data, passDetails };
                                        userDataLog = { ...userDataLog, requestPayload }
                                        responseLog = { ...userDataLog, responseLog }
                                        let setUserLog = eventCallRequest('Before Booking Data Save API Call Success', JSON.stringify(responseLog));
                                        this.props.eventRequest(setUserLog).then(() => { });

                                        const form = this.formRef.current
                                        form.submit()

                                        // REMOVED THE POP UP CODE NOW SUBMITTING FORM AS IN MAPCO
                                        // const paymentWindow = window.open('', 'formpopup', 'width=1000,height=900,resizeable,scrollbars');
                                        // if(isSafari){ 
                                        //     const notification = this.notificationSystem.current;
                                        //         notification.addNotification({
                                        //         title: 'Sorry!',
                                        //         message: 'Please allow the Pop-Up from browser settings to proceed further.',
                                        //         level: 'error'
                                        //     });
                                        // }

                                        // form.target = 'formpopup';
                                        // this.setState({ paymentScreenOpen: true })


                                        // let queries = queryString.parse(this.props.location.search)

                                        // if (queries.MerchantRef) {
                                        //     paymentWindow.close();
                                        //     this.setState({ paymentScreenOpen: false })
                                        // }                       
                                        // const paymentScreenOpenInterval = setInterval(() => {
                                        //     if (paymentWindow.closed) {
                                        //         paymentWindow.close();
                                        //         this.setState({ paymentScreenOpen: false })
                                        //         clearInterval(paymentScreenOpenInterval)
                                        //         const queries = JSON.parse(localStorage.getItem('queries'))
                                        //         if(queries.MerchantRef){
                                        //             const paymentStatus = localStorage.getItem('paymentStatus')

                                        //             if (paymentStatus === 'success') {
                                        //                 this.props.history.push("/payment-success");
                                        //             } else {
                                        //                 this.props.history.push("/payment-failure");
                                        //             }
                                        //         }
                                        //     }
                                        //     else {
                                        //         this.setState({ paymentScreenOpen: true })
                                        //     }
                                        // }, 1000);

                                    } else {
                                        let responseLog = res;
                                        this.setState({ paymentScreenOpen: false });

                                        let userDataLog = { ...user_Data, passDetails };
                                        userDataLog = { ...userDataLog, requestPayload }
                                        responseLog = { ...userDataLog, responseLog }
                                        let setUserLog = eventCallRequest('Before Booking Data Save API Call Failed', JSON.stringify(responseLog));
                                        this.props.eventRequest(setUserLog).then(() => { });
                                        this.setState({ paymentScreenOpen: false })
                                        const notification = this.notificationSystem.current;
                                        notification.addNotification({
                                            title: 'Sorry!',
                                            message: 'Something went wrong, please try after sometime.',
                                            level: 'error'
                                        });
                                    }

                                }).catch((err) => {
                                    let responseLog = err;
                                    this.setState({ paymentScreenOpen: false });

                                    let userDataLog = { ...user_Data, passDetails };
                                    userDataLog = { ...userDataLog, requestPayload }
                                    responseLog = { ...userDataLog, responseLog }
                                    let setUserLog = eventCallRequest('Before Booking Data Save API Call Failed', JSON.stringify(responseLog));
                                    this.props.eventRequest(setUserLog).then(() => { });
                                    this.setState({ paymentScreenOpen: false })
                                    const notification = this.notificationSystem.current;
                                    notification.addNotification({
                                        title: 'Sorry!',
                                        message: 'Something went wrong, please try after sometime.',
                                        level: 'error'
                                    });
                                })
                            } else {
                                const notification = this.notificationSystem.current;
                                this.setState({ paymentScreenOpen: false });

                                notification.addNotification({
                                    title: 'Sorry!',
                                    message: res ? res : 'Something went wrong, please try after sometime.',
                                    level: 'error'
                                });
                            }
                        }).catch((err) => {

                            const notification = this.notificationSystem.current;
                            this.setState({ paymentScreenOpen: false });

                            notification.addNotification({
                                title: 'Sorry!',
                                message: err,
                                level: 'error'
                            });
                        })

                    } else {
                        this.setState({ paymentScreenOpen: false });
                        notification.addNotification({
                            title: 'Card Expired! ',
                            message: 'Please select correct expiry date or another card.',
                            level: 'error'
                        });
                    }

                } else {
                    document.getElementById('ipg_form').reportValidity()
                    this.setState({ paymentScreenOpen: false });
                    // setError(true)
                    if (this.state.card_pan == '' || this.state.card_pan == null || this.state.card_pan.length < 15 || this.state.card_pan.length > 16) {
                        document.getElementById('card_pan').setCustomValidity('Please enter a valid card.')
                    }
                    else if (this.state.card_card_security_cvx_2 == '' || this.state.card_card_security_cvx_2 == null || this.state.card_card_security_cvx_2.length < 3 || this.state.card_card_security_cvx_2.length > 4) {
                        document.getElementById('card_card_security_cvx_2').setCustomValidity('Please enter a valid CVV number.')
                    }
                    else if (this.state.card_date_expiry_month == '' || this.state.card_date_expiry_month == null || this.state.card_date_expiry_year == '' || this.state.card_date_expiry_year == null) {
                        document.getElementById('expiration_date').setCustomValidity('Please enter card expiry.')
                    }
                    //  else if (this.state.card_date_expiry_year == '' || this.state.card_date_expiry_year == null) {
                    //     document.getElementById('card_date_expiry_year').setCustomValidity('Please enter expiry year.')
                    // }
                }


            }
        } else if(this.state.entry_date == 'Select Date'){
            notification.addNotification({
                title: '',
                message:  (this.state.bookingType === 'passPurchage' && this.props.passes.length > 0 && !this.state.isPassExits && this.state.isMember) ? 'Please Select Booking Pass.' : 'Please Select Booking Date.',
                level: 'error'
            });
        }
        else {
            notification.addNotification({
                title: 'Payment Session Expired! ',
                message: 'Please refresh and select a pass or booking again.',
                level: 'error'
            });
        }
    }


    EncryptionHandler = (d) => {
        var nonceString = d.name_on_card + ':' + d.card_number + ':' + d.expiration_date + ':' + d.security_code + ':' + d.zip_code;
        var CryptoJSAesJson = {
            stringify: function (cipherParams) {
                var j = {
                    ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
                    iv: '',
                    s: ''
                };
                if (cipherParams.iv)
                    j.iv = cipherParams.iv.toString();
                if (cipherParams.salt)
                    j.s = cipherParams.salt.toString();
                return JSON.stringify(j);
            },
            parse: function (jsonStr) {
                var j = JSON.parse(jsonStr);
                var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
                if (j.iv)
                    cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
                if (j.s)
                    cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
                return cipherParams;
            }
        };
        var encrypted = CryptoJS.AES.encrypt(JSON.stringify(nonceString), this.encryptKey, { format: CryptoJSAesJson }).toString();
        return encrypted;
    }

    componentDidUpdate = () => {
        const userQueries = localStorage.getItem('queries')
        const Query = userQueries !== '' ? JSON.parse(userQueries) : {}
        if (Query?.MerchantRef) {
            // this.setState({paymentScreenOpen:false})           
        }
    }



    handleInputChange = (event) => {
        let { name, value } = event.target;

        localStorage.setItem([name], value.trim())


        localStorage.setItem(name, value)
        this.setState({ [name]: value });
    }
    handleCardInputChange = (value) => {
        this.setState({ card_pan: value });
        localStorage.setItem('card_pan', value.substring(12, 16))
    }

    handlebookingType = (e, price = '') => {
        localStorage.setItem('isBooking', 0)
        const { name, value } = e.target
        if (value == 'oneDayPurchage') {
            this.handleDayPlanChange(price)
        }
        this.setState({ disableloader : true, passcheck : false, bookingType: value , passId : '' , entry_date : 'Select Date', also_selected : false ,  isSelectPass :  false,  isBooking: value == 'oneDayPurchage' ? true : false })

    }

    handlePassRateChange = (passId, price, length, option) => {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const isBooking = localStorage.getItem('isBooking')
        this.setState({ isBooking: false, isSelectPass: true, passId : passId , also_selected : true})
        const requestPayload = {
            'amount': price,
            'facility_id': userData?.garage_id ? userData?.garage_id : this.props.partnerDetails.facilities[0].id,
            'arrival': moment().format('MM/DD/yyyy'),
            'rate_id': passId,
            'is_booking_also': isBooking == 1 ? 3 : 2
        }
        let userDetails = JSON.parse(localStorage.getItem("userData"));
        userDetails = { ...userDetails, requestPayload }
        let setUserLog = eventCallRequest('IPG Session API Call', JSON.stringify(userDetails));
        this.props.eventRequest(setUserLog).then(() => { });
        this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
            if (res.data && res.data != null) {
                let setUserLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(userDetails));
                this.props.eventRequest(setUserLog).then(() => { });
                this.setState({ paymentSession: res?.data, passPrice: res?.data?.amount,  expiryTime: 900000 })
                localStorage.setItem('paymentSession', JSON.stringify(res?.data))
            } else {
                let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDetails));
                this.props.eventRequest(setUserLog).then(() => { });
                const notification = this.notificationSystem.current;
                notification.addNotification({
                    title: 'Sorry!',
                    message: "Error in session api",
                    level: 'error'
                });
                this.setState({ paymentSession: {} })
                localStorage.setItem('paymentSession', JSON.stringify({}))
            }
        }).catch((err) => {

            let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDetails));
            this.props.eventRequest(setUserLog).then(() => { });
            const notification = this.notificationSystem.current;
            notification.addNotification({
                title: 'Sorry!',
                message: err,
                level: 'error'
            });
            this.setState({ paymentSession: {} })
            localStorage.setItem('paymentSession', JSON.stringify({}))
        })

        this.setState({ pass_rate_id: passId, price: price, length: length, is_book_parking: false });
        const passDetails = { pass_rate_id: passId, price: price, length: length, is_book_parking: false }
        localStorage.setItem('passDetails', JSON.stringify(passDetails))
    }

    handleDayPlanChange = (price) => {
        const { getGaragePriceRes } = this.props;
        const userData = JSON.parse(localStorage.getItem('userData'))
        this.setState({ isBooking: true })
        const requestPayload = {
            'amount': price,
            'facility_id': userData?.garage_id ? userData?.garage_id : this.props.partnerDetails.facilities[0].id,
            'arrival': this.state.entry_date != 'Select Date' ?  this.state.entry_date : moment(new Date()).format('yyyy/MM/DD'),
            'rate_id': getGaragePriceRes?.id,
            'is_booking_also': 1
        }
        let userDetails = JSON.parse(localStorage.getItem("userData"));
        userDetails = { ...userDetails, requestPayload }
        let setUserLog = eventCallRequest('IPG Session API Call', JSON.stringify(userDetails));
        this.props.eventRequest(setUserLog).then(() => { });

        this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
            if (res.data && res.data != null) {
                let setUserLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(userDetails));
                this.props.eventRequest(setUserLog).then(() => { });

                this.setState({ paymentSession: res?.data, expiryTime: 900000 })
                localStorage.setItem('paymentSession', JSON.stringify(res?.data))
            } else {
                let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDetails));
                this.props.eventRequest(setUserLog).then(() => { });
                this.setState({ paymentSession: {} })
                localStorage.setItem('paymentSession', JSON.stringify({}))
                const notification = this.notificationSystem.current;
                notification.addNotification({
                    title: 'Sorry!',
                    message: 'Error in session api',
                    level: 'error'
                });
            }
        }).catch((err) => {

            let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDetails));
            this.props.eventRequest(setUserLog).then(() => { });
            this.setState({ paymentSession: {} })
            localStorage.setItem('paymentSession', JSON.stringify({}))
            const notification = this.notificationSystem.current;
            notification.addNotification({
                title: 'Sorry!',
                message: err,
                level: 'error'
            });
        })

        this.setState({ price: price, length: ApiConfig.defaultBookingLength, pass_rate_id: '', pass_id: '', is_book_parking: true });
        const planDetails = { price: price, length: ApiConfig.defaultBookingLength, pass_rate_id: '', pass_id: '', is_book_parking: true }
        localStorage.setItem('passDetails', JSON.stringify(planDetails))

    }

    consumeExistingPasses = (e, passId, price) => {
        const directBooking = {
            pass_id: passId,
            price: price,
            length: ApiConfig.defaultBookingLength
        }
        localStorage.setItem('directBooking', true)
        localStorage.setItem('directBookingData', JSON.stringify(directBooking))
        const user_Data = JSON.parse(localStorage.getItem('userData'))
        const paymentSession = JSON.parse(localStorage.getItem('paymentSession'))
        const notification = this.notificationSystem.current;
        if(this.state.entry_date_exist == 'Select Date'){
            notification.addNotification({
                title: '',
                message: 'Please Select Booking Date.',
                level: 'error'
            });
            return
        }

        const requestPayload = {
            name: user_Data?.user_name,
            email: user_Data?.email,
            phone: user_Data?.phone,
            arrival: this.state.entry_date_exist != 'Select Date' ?  this.state.entry_date_exist : moment(new Date()).format('yyyy/MM/DD'),
            mer_reference: paymentSession?.reference,
            facility_id: user_Data?.garage_id ? user_Data?.garage_id : this.props.partnerDetails.facilities[0].id,

        }
        this.checkValidationsWithCaptcha(requestPayload).then((res) => {
            if (res?.data === "success") {
                this.setState({ pass_id: passId, price: price, length: ApiConfig.defaultBookingLength }, () => {
                    const notification = this.notificationSystem.current;
                    this.setState({ isSubmitted: true }, () => {
                        let formData = {};
                        formData['length'] = this.state.length;
                        formData['facility_id'] = user_Data?.garage_id ? user_Data?.garage_id : this.state.userData.garage_id;
                        formData['member_id'] = (this.state.userData.is_member) ? this.state.userData.member_id : '';
                        formData['pass_id'] = this.state.pass_id;
                        formData['pass_rate_id'] = '';
                        formData['is_pass_purchase'] = 1;
                        formData['is_book_parking'] = 1;
                        formData['no_of_visitor'] = this.state.userData.no_of_visitors;
                        formData['description'] = "Reservation for Zoo Atlanta - A beginning at " + moment(this.state.entry_date, this.dateDisplayFormat).format('yyyy-MM-DD');
                        formData['total'] = 0;
                        formData['nonce'] = '';
                        formData['email'] = this.state.email;
                        formData['phone'] = this.state.userData.phone;
                        formData['name'] = this.state.userData.user_name;
                        formData['companyName'] = "";
                        formData['is_opt_out'] = "";
                        formData['use_bonus'] = 0;
                        formData['coupon_threshold_price'] = 0;
                        formData['warning_on_reservation'] = 0;
                        formData['warning_on_reservation_msg_email'] = "";
                        formData['is_card_req'] = 0;
                        formData['arrival'] = moment(this.state.entry_date_exist != 'Select Date' ? this.state.entry_date_exist : moment(new Date()).format('yyyy/MM/DD') , this.dateDisplayFormat).format('yyyy-MM-DD') + " 00:00:00";

                        this.makePaymentWithCaptcha(formData).then(() => {
                            const { paymentRes, hasError, errorMessage } = this.props;
                            if (hasError) {
                                let eventParams = eventCallRequest('Existing Pass Payment API Failed', JSON.stringify(errorMessage));
                                this.props.eventRequest(eventParams).then(() => { });

                                this.setState({ isSubmitted: false }, () => {
                                    notification.addNotification({
                                        title: 'Sorry!',
                                        message: errorMessage,
                                        level: 'error'
                                    });
                                });
                            } else {
                                localStorage.setItem('reservationDetails', JSON.stringify(paymentRes));
                                let eventParams = eventCallRequest('Existing Pass Payment API Success', JSON.stringify(paymentRes), this.state.userData.garage_id);
                                this.props.eventRequest(eventParams).then(() => { });
                                if ((paymentRes?.reservation ? Object.values(paymentRes?.reservation).length > 0 : false) && (paymentRes?.pass ? Object.values(paymentRes?.pass).length > 0 : false)) {
                                    let confirmationData = {
                                        booking_date: paymentRes.reservation.formatted_start_date,
                                        valid_till: paymentRes.pass.end_date,
                                        phone: paymentRes.reservation.user.phone,
                                        email: paymentRes.reservation.user.email,
                                        is_pass: 1,
                                        ticketech_code: paymentRes.reservation.ticketech_code,
                                        pass_code: paymentRes.pass.pass_code
                                    }
                                    localStorage.setItem('reservationData', JSON.stringify(confirmationData));
                                    this.props.history.push("/booking-response");
                                } else if (paymentRes?.reservation ? Object.values(paymentRes?.reservation).length > 0 : false) {
                                    let confirmationData = {
                                        booking_date: paymentRes.reservation.formatted_start_date,
                                        phone: paymentRes.reservation.user.phone,
                                        email: paymentRes.reservation.user.email,
                                        is_pass: 0,
                                        ticketech_code: paymentRes.reservation.ticketech_code,
                                    }
                                    localStorage.setItem('reservationData', JSON.stringify(confirmationData));
                                    this.props.history.push("/booking-response");
                                } else if (paymentRes?.pass ? Object.values(paymentRes?.pass).length > 0 : false) {
                                    let confirmationData = {
                                        valid_till: paymentRes.pass.end_date,
                                        phone: paymentRes.pass.user.phone,
                                        email: paymentRes.pass.user.email,
                                        is_pass: 1,
                                        pass_code: paymentRes.pass.pass_code
                                    }
                                    localStorage.setItem('reservationData', JSON.stringify(confirmationData));
                                    this.props.history.push("/booking-response");
                                }
                            }
                        }).catch((err) => {
                            const notification = this.notificationSystem.current;
                            notification.addNotification({
                                title: 'Sorry!',
                                message: err,
                                level: 'error'
                            });
                        })
                    });
                    e.preventDefault();
                });
            } else {
                localStorage.setItem('directBooking', '')
                localStorage.setItem('directBookingData', JSON.stringify({}))
                const notification = this.notificationSystem.current;
                notification.addNotification({
                    title: 'Sorry!',
                    message: res ? res : 'Something went wrong, please try after sometime.',
                    level: 'error'
                });
            }
        }).catch((err) => {
            localStorage.setItem('directBooking', '')
            localStorage.setItem('directBookingData', JSON.stringify({}))
            const notification = this.notificationSystem.current;
            notification.addNotification({
                title: 'Sorry!',
                message: err,
                level: 'error'
            });
        })

    }

    handleDayBookingWithParking = (e , check) => {

        if (e.target.checked) {
            // Refresh the planet session if booking is also done with pass purchase
            const userData = JSON.parse(localStorage.getItem('userData'))
            const passDetails = JSON.parse(localStorage.getItem('passDetails'))
            this.setState({passcheck : true , disableloader : check , entry_date: this.state?.entry_date && this.state?.entry_date != 'Select Date' ? this.state?.entry_date : moment().format('MM/DD/yyyy')})
            const requestPayload = {
                'amount': passDetails?.price,
                'facility_id': userData?.garage_id ? userData?.garage_id : this.props.partnerDetails.facilities[0].id,
                'arrival':  this.state?.entry_date != 'Select Date' ? this.state?.entry_date : moment().format('MM/DD/yyyy'),
                'rate_id': passDetails?.pass_rate_id,
                'is_booking_also': 3
            }
            this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
                if (res.data && res.data != null) {
                    let setUserLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(requestPayload));
                    this.props.eventRequest(setUserLog).then(() => { });

                    this.setState({ paymentSession: res?.data,expiryTime: 900000 })
                    localStorage.setItem('paymentSession', JSON.stringify(res?.data))
                } else {
                    let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(requestPayload));
                    this.props.eventRequest(setUserLog).then(() => { });
                    this.setState({ paymentSession: {}})
                    localStorage.setItem('paymentSession', JSON.stringify({}))
                    const notification = this.notificationSystem.current;
                    notification.addNotification({
                        title: 'Sorry!',
                        message: 'Error in session api',
                        level: 'error'
                    });
                }
                // this.setState({paymentSession: res?.data})
                // localStorage.setItem('paymentSession', JSON.stringify(res?.data))
            }).catch((err) => {
                const notification = this.notificationSystem.current;
                notification.addNotification({
                    title: 'Sorry!',
                    message: err,
                    level: 'error'
                });
                this.setState({ paymentSession: {}})
                localStorage.setItem('paymentSession', JSON.stringify({}))
            })
            // Refresh the planet session if booking is also done with pass purchase
            localStorage.setItem('isBooking', 1)
            const notification = this.notificationSystem.current;
            let calLength = ApiConfig.defaultBookingLength;
            this.setState({ length: calLength }, () => {
                let formData = {
                    "use_bonus": 0,
                    "is_member": (this.state.isMember) ? 1 : 0,
                    "length_of_stay": this.state.length,
                    "arrival_time": this.state?.entry_date && this.state?.entry_date != 'Select Date' ? moment(this.state.entry_date, this.dateDisplayFormat).format(this.senddateTimeFormat) : moment().format('MM/DD/yyyy'),
                    "garage_id": this.state.userData.garage_id
                }
                this.setState({ entry_date : this.state?.entry_date && this.state.entry_date != 'Select Date' ? this.state?.entry_date : moment().format('MM/DD/yyyy')})
                if (this.state.length < ApiConfig.defaultBookingLength) {
                    notification.addNotification({
                        title: 'Sorry ! Request failed.',
                        message: "Length should not be less than " + ApiConfig.defaultBookingLength + " hours!!!",
                        level: 'error'
                    });
                } else {
                    this.getGaragePriceWithCaptcha(formData).then(() => {
                        const { getGaragePriceRes, hasError, errorMessage } = this.props;
                        let userDetails = JSON.parse(localStorage.getItem("userData"))
                        userDetails = { ...errorMessage, userDetails }
                        if (hasError) {
                            let eventParams = eventCallRequest('Fetch Booking Rate API Failed', JSON.stringify(userDetails));
                            this.props.eventRequest(eventParams).then(() => { });
                        } else {
                            userDetails = { ...getGaragePriceRes, userDetails }

                            let eventParams = eventCallRequest('Fetch Booking Rate API Success', JSON.stringify(userDetails), this.state.userData.garage_id);
                            this.props.eventRequest(eventParams).then(() => { });
                        }

                        this.setState({ price: getGaragePriceRes.price, is_book_parking: true, passWithParking: true, length: ApiConfig.defaultBookingLength });
                    })
                }
            })
        } else {
            this.setState({entry_date: 'Select Date' , passcheck : false})
            // Refresh the planet session if booking is also done with pass purchase
            const userData = JSON.parse(localStorage.getItem('userData'))
            const passDetails = JSON.parse(localStorage.getItem('passDetails'))
            const requestPayload = {
                'amount': passDetails?.price,
                'facility_id': userData?.garage_id ? userData?.garage_id : this.props.partnerDetails.facilities[0].id,
                'arrival':this.state.entry_date != 'Select Date' ?  this.state.entry_date : moment(new Date()).format('yyyy/MM/DD'),
                'rate_id': passDetails?.pass_rate_id,
                'is_booking_also': 2
            }
            this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
                if (res.data && res.data != null) {
                    let setUserLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(requestPayload));
                    this.props.eventRequest(setUserLog).then(() => { });

                    this.setState({ paymentSession: res?.data, expiryTime: 900000 })
                    localStorage.setItem('paymentSession', JSON.stringify(res?.data))
                } else {
                    let setUserLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(requestPayload));
                    this.props.eventRequest(setUserLog).then(() => { });
                    this.setState({ paymentSession: {} })
                    localStorage.setItem('paymentSession', JSON.stringify({}))
                    const notification = this.notificationSystem.current;
                    notification.addNotification({
                        title: 'Sorry!',
                        message: 'Error in session api',
                        level: 'error'
                    });
                }
                // this.setState({})
                // localStorage.setItem('paymentSession', JSON.stringify(res?.data))
            }).catch((err) => {
                const notification = this.notificationSystem.current;
                notification.addNotification({
                    title: 'Sorry!',
                    message: err,
                    level: 'error'
                });
                this.setState({ paymentSession: {} })
                localStorage.setItem('paymentSession', JSON.stringify({}))
            })
            // Refresh the planet session if booking is also done with pass purchase
            localStorage.setItem('isBooking', 0)
            this.setState({ is_book_parking: false, passWithParking: false, length: ApiConfig.defaultBookingLength });
        }
    }

    existingPassDateChangeHandler = (date ) => {
        let entryDate = this.state.entry_date_exist;
        entryDate = moment(date).format(this.dateDisplayFormat);
        this.setState({ entry_date_exist :  entryDate, isExistingPassed : true})
        localStorage.setItem('entry_date', entryDate)
    }

    oneDayDateChangeHandler = (date) => {

        let entryDate = this.state.entry_date;
        const notification = this.notificationSystem.current;
        entryDate = moment(date).format(this.dateDisplayFormat);
        this.setState({ entry_date: entryDate , disableloader : true}, () => {

            localStorage.setItem('entry_date', entryDate)
            localStorage.setItem('isBooking', 0)
            let calLength = ApiConfig.defaultBookingLength;
            this.setState({ length: calLength }, () => {
                let formData = {
                    "use_bonus": 0,
                    "length_of_stay": this.state.length,
                    "is_member": (this.state.isMember) ? 1 : 0,
                    "arrival_time": moment(date).format(this.senddateTimeFormat),
                    "garage_id": this.state.userData.garage_id
                }

                if (this.state.length < ApiConfig.defaultBookingLength) {
                    notification.addNotification({
                        title: 'Sorry ! Request failed.',
                        message: "Length should not be less than 2 hours!!!",
                        level: 'error'
                    });
                } else {
                    this.getGaragePriceWithCaptcha(formData).then(() => {
                        const { getGaragePriceRes, hasError, errorMessage } = this.props;
                        let userDetails = JSON.parse(localStorage.getItem("userData"))
                        userDetails = { ...errorMessage, userDetails }
                        if (hasError) {
                            let eventParams = eventCallRequest('Fetch Booking Rate API Failed', JSON.stringify(userDetails));
                            this.props.eventRequest(eventParams).then(() => { });
                        } else {
                            userDetails = { ...getGaragePriceRes, userDetails }

                            let eventParams = eventCallRequest('Fetch Booking Rate API Success', JSON.stringify(userDetails), this.state.userData.garage_id);
                            this.props.eventRequest(eventParams).then(() => { });
                            // Get Planet Session
                            if (!this.state.pass_rate_id) {
                                const requestPayload = {
                                    'amount': getGaragePriceRes?.price,
                                    'facility_id': this.state.userData?.garage_id ? this.state.userData?.garage_id : this.props.partnerDetails.facilities[0].id,
                                    'rate_id': getGaragePriceRes?.id,
                                    'is_booking_also': 1,
                                    'arrival': moment(date).format(this.senddateTimeFormat),
                                }
                                let userDataLog = localStorage.getItem("userData");
                                userDataLog = { ...errorMessage, userDataLog }
                                let sessionLog = eventCallRequest('IPG Session API Call', JSON.stringify(userDataLog));
                                this.props.eventRequest(sessionLog).then(() => { });
                                this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
                                    if (res.data && res.data != null) {
                                        let sessionLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(userDataLog));
                                        this.props.eventRequest(sessionLog).then(() => { });
                                        this.setState({ paymentSession: res?.data, expiryTime: 900000 })
                                        localStorage.setItem('paymentSession', JSON.stringify(res?.data))
                                    } else {
                                        notification.addNotification({
                                            title: 'Sorry!',
                                            message: 'There is some Problem with Payment Gateway',
                                            level: 'error'
                                        });
                                        this.setState({ paymentSession: {} })
                                        localStorage.setItem('paymentSession', JSON.stringify({}))
                                        let sessionLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                        this.props.eventRequest(sessionLog).then(() => { });

                                    }

                                }).catch((err) => {
                                    notification.addNotification({
                                        title: 'Sorry!',
                                        message: err,
                                        level: 'error'
                                    });
                                    this.setState({ paymentSession: {} })
                                    localStorage.setItem('paymentSession', JSON.stringify({}))
                                    let sessionLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                    this.props.eventRequest(sessionLog).then(() => { });

                                })
                            }
                        }
                    })
                }
            })
        })
    }

    oneDayDateChangeHandleralso = (date) => {

        let entryDate = this.state.entry_date;
        const notification = this.notificationSystem.current;
        entryDate = moment(date).format(this.dateDisplayFormat);
        this.setState({ entry_date: entryDate , disableloader : true}, () => {

            localStorage.setItem('entry_date', entryDate)
            localStorage.setItem('isBooking', 1)
            let calLength = ApiConfig.defaultBookingLength;
            this.setState({ length: calLength }, () => {
                let formData = {
                    "use_bonus": 0,
                    "length_of_stay": this.state.length,
                    "is_member": (this.state.isMember) ? 1 : 0,
                    "arrival_time": moment(date).format(this.senddateTimeFormat),
                    "garage_id": this.state.userData.garage_id
                }

                if (this.state.length < ApiConfig.defaultBookingLength) {
                    notification.addNotification({
                        title: 'Sorry ! Request failed.',
                        message: "Length should not be less than 2 hours!!!",
                        level: 'error'
                    });
                } else {
                    this.getGaragePriceWithCaptcha(formData).then(() => {
                        const { getGaragePriceRes, hasError, errorMessage } = this.props;
                        let userDetails = JSON.parse(localStorage.getItem("userData"))
                        userDetails = { ...errorMessage, userDetails }
                        if (hasError) {
                            let eventParams = eventCallRequest('Fetch Booking Rate API Failed', JSON.stringify(userDetails));
                            this.props.eventRequest(eventParams).then(() => { });
                        } else {
                            userDetails = { ...getGaragePriceRes, userDetails }

                            let eventParams = eventCallRequest('Fetch Booking Rate API Success', JSON.stringify(userDetails), this.state.userData.garage_id);
                            this.props.eventRequest(eventParams).then(() => { });
                            // Get Planet Session
                            if (!this.state.pass_rate_id) {
                                const requestPayload = {
                                    'amount': getGaragePriceRes?.price,
                                    'facility_id': this.state.userData?.garage_id ? this.state.userData?.garage_id : this.props.partnerDetails.facilities[0].id,
                                    'rate_id': getGaragePriceRes?.id,
                                    'is_booking_also': 1,
                                    'arrival': moment(date).format(this.senddateTimeFormat),
                                }
                                let userDataLog = localStorage.getItem("userData");
                                userDataLog = { ...errorMessage, userDataLog }
                                let sessionLog = eventCallRequest('IPG Session API Call', JSON.stringify(userDataLog));
                                this.props.eventRequest(sessionLog).then(() => { });
                                this.getPaymentSessionWithCaptcha(requestPayload).then((res) => {
                                    if (res.data && res.data != null) {
                                        let sessionLog = eventCallRequest('IPG Session API Call Success', JSON.stringify(userDataLog));
                                        this.props.eventRequest(sessionLog).then(() => { });
                                        this.setState({ paymentSession: res?.data, expiryTime: 900000 })
                                        localStorage.setItem('paymentSession', JSON.stringify(res?.data))
                                    } else {
                                        notification.addNotification({
                                            title: 'Sorry!',
                                            message: 'There is some Problem with Payment Gateway',
                                            level: 'error'
                                        });
                                        this.setState({ paymentSession: {} })
                                        localStorage.setItem('paymentSession', JSON.stringify({}))
                                        let sessionLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                        this.props.eventRequest(sessionLog).then(() => { });

                                    }

                                }).catch((err) => {
                                    notification.addNotification({
                                        title: 'Sorry!',
                                        message: err,
                                        level: 'error'
                                    });
                                    this.setState({ paymentSession: {} })
                                    localStorage.setItem('paymentSession', JSON.stringify({}))
                                    let sessionLog = eventCallRequest('IPG Session API Call Failed', JSON.stringify(userDataLog));
                                    this.props.eventRequest(sessionLog).then(() => { });

                                })
                            }
                        }
                    })
                }
            })
        })
    }

    renderRemainingDays = (no_of_days, consume_days) => {
        var tmp = [];
        for (var i = 0; i < no_of_days; i++) {
            tmp.push(i);
        }
        var list = tmp.map(function (i) {
            return (i < consume_days) ? <span key={i} className='bg-gray'>&nbsp;</span> : <span key={i} className='bg-success'>&nbsp;</span>
        });
        return list;
    }



    render() {
        // const { userData, isSubmitted, existPass,bookingType } = this.state;
        // const { passes, isFetching, getGaragePriceRes, userPasses, partnerDetails } = this.props;
        // const yesterday = moment(new Date()).subtract(1, 'day');
        // const disablePastDt = current => { return current.isAfter(yesterday) }
        const { userData, isSubmitted, existPass, expiry, bookingType , disableloader} = this.state;
        const { passes, isFetching, getGaragePriceRes, userPasses, partnerDetails } = this.props;
        const yesterday = moment(new Date()).subtract(1, 'day');
        const disablePastDt = current => { return current.isAfter(yesterday) }
        return (
            <Aux>
                {/* {this.state.paymentScreenOpen && <LoadingComponent />} */}
                <NotificationSystem ref={this.notificationSystem} />
                <div className="container-fluid">
                    <div className="row no-gutters">
                        <div className="col">
                            <div className="col my-4 text-center">
                                <Link to="/" className='text-decoration-none'>
                                    <h5 className="fw-bold text-primary"><img alt="" height="20px" style={{ marginRight: '5px' }} src={Logo} />Parking at Grant Park Gateway Deck</h5>
                                </Link>
                            </div>
                            <CarouselItems />
                            <BottomLogo
                                className="my-2 text-center bg-opacity-10 d-none d-sm-block"
                            />
                        </div>
                        <div className={`col-sm-12 col-md-7 col-12 bg-white p-0 border-start ${!getGaragePriceRes ? 'd-flex justify-content-center align-items-center' : ''}`}>
                        {getGaragePriceRes ? <div className="ContentWrapper ">
                                {userData &&
                                    <div className=" user-data card-header shadow ">
                                        <div className="row aling-items-center">
                                            <div className="col-12 col-sm ">
                                                <h3 className=" mt-0 font-weight-bold text-capitalize textcolor2"><b className="text-dark lead">Hello</b>&nbsp;{userData.user_name}!</h3>
                                            </div>
                                        </div>
                                        <div className="border-top mt-2">
                                            <div className="row justify-content-between align-items-center my-3">
                                                {(userData.member_id) ? <div className="col-12 col-sm-auto">
                                                    <p className="m-0"><b>Member ID</b> : {userData.member_id}</p>
                                                </div> : ''}
                                                <div className="col-12 col-sm-auto">
                                                    <p className="m-0"><b><i className="fa fa-phone"></i></b> : {conformToMask(userData.phone, this.phoneNumberMask).conformedValue} </p>
                                                </div>
                                                {/* {((partnerDetails.facilities) && (partnerDetails.facilities[0].processing_fee > 0)) && <div className="col-sm-4 col-sm pr-3">
                                                    <p className="m-0"><b>Processing Fee</b> : ${partnerDetails.facilities[0].processing_fee} </p>
                                                </div>} */}
                                                {((partnerDetails.facilities) && (Number(this.props.getGaragePriceRes && this.props.getGaragePriceRes?.processing_fee ? this.props.getGaragePriceRes?.processing_fee : '0') > 0)) && <div className="col-12 col-sm-auto pr-3">
                                                    <p className="m-0"><b>Processing Fee</b> : ${this.props.getGaragePriceRes && this.props.getGaragePriceRes?.processing_fee ? this.props.getGaragePriceRes?.processing_fee : '0.00'} </p>
                                                </div>}
                                                {((partnerDetails.facilities) && (Number(this.props.getGaragePriceRes && this.props.getGaragePriceRes?.tax_fee ? this.props.getGaragePriceRes.tax_fee : '0') > 0)) && <div className="col-12 col-sm-auto pr-3">
                                                    <p className="m-0"><b>Tax Fee</b> : ${this.props.getGaragePriceRes && this.props.getGaragePriceRes?.tax_fee ? this.props.getGaragePriceRes.tax_fee : '0'} </p>
                                                </div>}
                                            </div>
                                        </div> 
                                    </div>}
                                <div style={{ position: 'relative' }} >
                                    <div className="content-body">
                                        {(isSubmitted || (isFetching && disableloader) || this.state.paymentScreenOpen) ? <LoadingComponent /> : ''}
                                        {this.state.isPassExits &&
                                            <div className="card shadow coupon-box mb-3">
                                                <div className="card-header">
                                                    <b>Your Pass</b>
                                                </div>
                                                {userPasses.map((userPass, k) => {
                                                    return (<div key={k} className="card-body  border-top">
                                                        <div className='row  g-sm-1 g-3 justify-content-between'>
                                                            <div className=' order-0 col-sm-auto'>
                                                                <div className='d-flex gap-2'>
                                                                    <span>
                                                                        <img alt="" className="mr-1" src={coupon} width="22" />
                                                                    </span>

                                                                    <div>
                                                                        <h5 className='d-block m-0 fw-bold'> {userPass.rate.description} &nbsp;|&nbsp; ${userPass.total}</h5>
                                                                        <small>Pass expiring on {moment(userPass.end_date).format('Do MMMM, YYYY')}</small>
                                                                    </div>

                                                                </div>


                                                            </div>
                                                            <div className='order-1 col-sm-auto'>
                                                                <div className='d-flex align-items-center gap-2 '>
                                                                    <label className='fw-bold text-nowrap' >  Parking Date</label>
                                                                    <span className="datePicker datePickerSm ">
                                                                        <i className="fa  fa-calendar"></i>
                                                                        <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date_exist} value={this.state.entry_date_exist} onChange={this.existingPassDateChangeHandler} />
                                                                    </span>



                                                                </div>
                                                            </div>
                                                            
                                                            <div className='col-sm-auto order-4 order-sm-2'>
                                                                {/* TEMPORARY HIDING CARD DETAILS FOR STOPING RESERVATIONS ON 10TH and 11TH AUGUST AS
                                            PER REQUIREMENT IN LIVE FOR CLIENT */}
                                                                {(userPass.total_days == userPass.consume_days || (this.state.entry_date_exist == '08/11/2024' || this.state.entry_date_exist == '08/10/2024')) ? <button disabled={true} type="submit" className="btn btn-primary  w-100 w-sm-auto">Book Parking</button> : <button type="submit" onClick={(event) => this.consumeExistingPasses(event, userPass.id, userPass.total)} className="btn btn-primary  w-100 w-sm-auto">Book Parking</button>}
                                                            </div>

                                                            <div className=' col-12 order-3 d-flex flex-sm-row flex-column gap-3 mt-3 justify-content-sm-between' >

                                                                <div className='daysCount'>
                                                                    {this.renderRemainingDays(userPass.total_days, userPass.consume_days)}
                                                                </div>
                                                                <span className='d-block text-nowrap'>
                                                                    {userPass.consume_days}  out of {userPass.total_days} {(userPass.total_days == 1) ? 'day' : 'days'} used</span>

                                                            </div>
                                                        </div>
                                                        {/* TEMPORARY HIDING CARD DETAILS FOR STOPING RESERVATIONS ON 10TH and 11TH AUGUST AS
                                            PER REQUIREMENT IN LIVE FOR CLIENT */}
                                                        {this.state.entry_date_exist == '08/11/2024' || this.state.entry_date_exist == '08/10/2024' ? <div className="card oneDayParking">
                                                            <div className="box-2 card-body border-top">
                                                                <div className='row'>
                                                                    <div className='col-12 fw-bold text-danger d-flex justify-content-center'>
                                                                        <h4 className='fw-bold'>Parking is free....no need to make a reservation!</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> : null}
                                                    </div>)
                                                })}
                                            </div>}

                                        {this.state.isPassExits && <div className="or-devide">
                                            <p><span>Or Without Using Pass</span></p>
                                        </div>}
                                        <form ref={this.formRef} action={getSessionAttribute('api_url')} target="_top" id='ipg_form' name='ipg_form' method='post'>

                                            {/* first */}
                                            {!this.state.isPassExits && this.state.isMember && <div className="card oneDayParking mb-3">
                                                {/* {(this.state.isMember && !this.state.isPassExits) && <div className="card-header">
                                                    <b>Buy Pass or One Day Parking</b>
                                                </div>}
                                                {(this.state.isMember && this.state.isPassExits) && <div className="card-header">
                                                    <b>Buy One Day Parking</b>
                                                </div>}
                                                {(!this.state.isMember) && <div className="card-header">
                                                    <b>Buy One Day Parking</b>
                                                </div>} */}
                                                <div className='card-header'>


                                                    {(!this.state.isPassExits) && <div className="form-check">
                                                        <input className="form-check-input" type="radio" value={'passPurchage'} id='purchasePass' required onChange={(e) => this.handlebookingType(e)} name="bookingTypePass" checked={this.state.bookingType === 'passPurchage'} />
                                                        <label className="form-check-label fw-bold " for="purchasePass">
                                                            Purchase Pass
                                                        </label>
                                                    </div>}




                                                </div>


                                                {this.state.isMember && <div className={`${bookingType == 'oneDayPurchage' ? 'card-body disabled' : 'card-body'}`}>
                                                    {!this.state.isPassExits && <div className="row g-2 justify-content-left radioButtons  bypass-tab">
                                                        {/* <input type="radio" hidden id={0} className="" name="pass"  checked={this.state.isSelectPass ? false : true}  /> */}

                                                        {(passes.length > 0) && passes.map((pass, key) => {
                                                            if (pass.rate_type == 'Pass Rates') {
                                                                return pass.rates.map((p, k) => {
                                                                    let option = 'option' + k;
                                                                    return (<div key={k} className="col-12 col-sm-4 mb-2">
                                                                        
                                                                        <input type="radio" checked={this.state.passId == p.id} id={option} onChange={() => this.handlePassRateChange(p.id, p.price, p.max_stay, option)} className="" name="pass" />
                                                                        <label className="btn btn-secondary py-3" htmlFor={option}> <img alt="" className="mr-2" src={coupon} width="22" />{p.description} ${p.price}</label>
                                                                    </div>)
                                                                })
                                                                
                                                            }
                                                        })}
                                                    </div>}
                                                    <div className={(this.state.isPassExits) ? "book-park" : "border-top mt-2 py-2"}>

                                                        {(Object.values(getGaragePriceRes).length > 0) && this.state.bookingType == 'passPurchage' ?
                                                            (
                                                                this.state.also_selected && <>
                                                                {/* <div className="col-sm-12 col-md-12 mt-2 mb-2 checkbox d-block">
                                                                    <p className="mb-0">
                                                                        <input type="checkbox" id="parkalso" onChange={(e) => this.handleDayBookingWithParking(e)} name="1day" />
                                                                        <label className="radio-label" for="parkalso">Book Parking Also</label>
                                                                    </p>
                                                                </div> */}
                                                                <div className='d-sm-flex gap-3 priceBlock position-relative align-items-center '>

                                                                    {/* <b className="radioLink">
                                                                                {(!this.state.isPassExits) && <input type="radio" required onChange={() => this.handleDayPlanChange(getGaragePriceRes.price)} name="pass" checked={this.state.isBooking} />}
                                                                                <label className="radio-label">1 Day Parking</label>
                                                                            </b> */}

                                                                    <input class="form-check-input m-0" type="checkbox" value=""  onChange={(e) => this.handleDayBookingWithParking(e , false)} name="1day" id="flexCheckIndeterminateDisabled" />
                                                                    
                                                                    <label class="form-check-label fw-bold" for="flexCheckIndeterminateDisabled">
                                                                        Select Parking Date                                                                 </label>


                                                                    <span className=  {this.state.passcheck ? "datePicker" : "datePicker  disabled"}>
                                                                        <i className="fa  fa-calendar"></i>
                                                                        <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandleralso} />

                                                                    </span>



                                                                    <div className="priceTag">{(this.state.passPrice && this.state.passPrice != 'N/A') ? "$" + Number(this.state.passPrice).toFixed(2) : ''}<br /><small>(Amount Due)</small></div>
                                                                </div>
                                                                    <small className='mt-2 d-block'  ><sup className='text-danger'>**</sup>You can also book a parking slot against the pass you are purchasing.</small>
                                                                </>
                                                            ) : ''}

                                                    </div>
                                                </div>}

                                                {(!this.state.isMember) && <div className="card-body">
                                                    <div className="book-park">
                                                        <table className="table radio table-park table-borderless">
                                                            <tbody>
                                                                {(Object.values(getGaragePriceRes).length > 0) ?
                                                                    (<tr>
                                                                        <td className="td1">
                                                                            <b className="radioLink">
                                                                                {/* <input type="radio" onChange={() => this.handleDayPlanChange(getGaragePriceRes.price)} name="pass" /> */}
                                                                                <label className="radio-label">1 Day Parking</label>
                                                                            </b>
                                                                            <span>Parking Date</span>
                                                                            <span className="datePicker datepic-small">
                                                                                <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandler} />
                                                                                <i className="fa listBlockWrap fa-calendar"></i>
                                                                            </span>
                                                                        </td>
                                                                        <th className="th1">{(getGaragePriceRes.price != 'N/A') ? "$" + getGaragePriceRes.price : getGaragePriceRes.price}</th>
                                                                    </tr>) : ''}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>}

                                                {(this.state.pass_rate_id) && <div className="box-2 card-body border-top d-none">
                                                    <div className="row">
                                                        <div className="col-sm-12 col-md-auto mt-2 checkbox">
                                                            <p className="mb-0">
                                                                <input type="checkbox" id="parkalso" onChange={(e) => this.handleDayBookingWithParking(e , true)} name="1day" />
                                                                <label className="radio-label" for="parkalso">Book Parking Also</label>
                                                            </p>
                                                        </div>
                                                        <div className="col-sm-12 col-md my-2">
                                                            <p>
                                                                <span>Parking Date</span>
                                                                <span className="datePicker datepic-small">
                                                                    <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandler} />
                                                                    <i className="fa listBlockWrap fa-calendar"></i>
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div></div>}


                                            </div>}

                                            {/* second */}
                                            <div className="card oneDayParking mb-3">
                                                {/* {(this.state.isMember && !this.state.isPassExits) && <div className="card-header">
                                                    <b>Buy Pass or One Day Parking</b>
                                                </div>}
                                                {(this.state.isMember && this.state.isPassExits) && <div className="card-header">
                                                    <b>Buy One Day Parking</b>
                                                </div>} */}
                                                {/* <div className="card-header">
                                                <b className="radioLink">
                                                    {(!this.state.isPassExits) && <input type="radio" required onChange={() => this.handleDayPlanChange(getGaragePriceRes.price)} name="pass" checked={this.state.isBooking} />}
                                                    <label className="radio-label">1 Day Parking</label>
                                                </b>
                                                </div> */}
                                                <div className='card-header'>


                                                   
                                                       {this.state.isMember ?  <div className="form-check"><input className="form-check-input" type="radio" value={'oneDayPurchage'} id='oneDayParking' onChange={(e) => this.handlebookingType(e, getGaragePriceRes.price)} name="bookingTypePass" checked={this.state.bookingType === 'oneDayPurchage'} />

                                                        <label className="form-check-label fw-bold " for="oneDayParking">
                                                            One Day Parking
                                                        </label>
                                                    </div> : <label className=" fw-bold " >
                                                            One Day Parking
                                                        </label>}




                                                </div>
                                                {/* {(!this.state.isMember) && <div className="card-header">
                                                    <b>Buy One Day Parking</b>
                                                </div>} */}
                                                {this.state.isMember &&
                                                    <div className={`${(bookingType == 'passPurchage' && !this.state.isPassExits) ? 'card-body disabled' : 'card-body'}`}>

                                                        <div className={(this.state.isPassExits) ? "book-park" : ""}>

                                                            {(Object.values(getGaragePriceRes).length > 0) ?
                                                                (<><div className='d-sm-flex gap-3 justify-content-between priceBlock position-relative align-items-center '>

                                                                    {/* <b className="radioLink">
                                                                                {(!this.state.isPassExits) && <input type="radio" required onChange={() => this.handleDayPlanChange(getGaragePriceRes.price)} name="pass" checked={this.state.isBooking} />}
                                                                                <label className="radio-label">1 Day Parking</label>
                                                                            </b> */}
                                                                    <div className='d-flex gap-2 align-items-center' >
                                                                        {/* <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminateDisabled" /> */}
                                                                        <label class=" fw-bold" for="flexCheckIndeterminateDisabled">
                                                                            Select Parking Date </label>
                                                                    
                                                                        {(bookingType == 'passPurchage' && !this.state.isPassExits) ? <span className="datePicker ">
                                                                            <i className="fa  fa-calendar"></i>
                                                                            <input className='form-control'  placeholder='Select Date'></input>

                                                                        </span> :
                                                                        <span className="datePicker ">
                                                                            <i className="fa  fa-calendar"></i>
                                                                            <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={!this.state.isSelectPass ?  this.state.entry_date : 'Select Date'} value={!this.state.isSelectPass ? this.state.entry_date : 'Select Date'} onChange={this.oneDayDateChangeHandler} />

                                                                        </span>}
                                                                    </div>
                                                                    {(this.state.entry_date != 'Select Date') ? !this.state.isSelectPass ? <div className="priceTagalt ">{(getGaragePriceRes.payable_amount != 'N/A') ? "$" + getGaragePriceRes.payable_amount : getGaragePriceRes.payable_amount}<br /><small className='text-dark' >(Amount Due)</small></div> : '' : ''}
                                                                </div>

                                                                </>) : ''}
                                                            {/* old */}
                                                            {/* <table className="table radio table-park table-borderless">
                                                            <tbody>
                                                                {(Object.values(getGaragePriceRes).length > 0) ?
                                                                    (<tr>
                                                                        <td className="td1">

                                                                            <span>Parking Date ll</span>
                                                                            <span className="datePicker datepic-small">
                                                                                <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandler} />
                                                                                <i className="fa listBlockWrap fa-calendar"></i>
                                                                            </span>
                                                                        </td>
                                                                        <th className="th1">{(getGaragePriceRes.price != 'N/A') ? "$" + getGaragePriceRes.price : getGaragePriceRes.price}</th>
                                                                    </tr>) : ''}
                                                            </tbody>
                                                        </table> */}
                                                        </div>
                                                    </div>}
                                                {(!this.state.isMember) && <div className="card-body">
                                                    <div className="book-park">
                                                        <table className="table radio table-park table-borderless">
                                                            <tbody>
                                                                {(getGaragePriceRes && Object.values(getGaragePriceRes).length > 0) ?
                                                                    (<><div className='d-sm-flex gap-3 justify-content-between priceBlock position-relative align-items-center '>

                                                                        <div className='d-flex gap-2 align-items-center' >

                                                                            {/* <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminateDisabled" /> */}
                                                                            <label class="form-check-label fw-bold" for="flexCheckIndeterminateDisabled">
                                                                                Select Parking Date
                                                                            </label>


                                                                            <span className="datePicker ">
                                                                                <i className="fa  fa-calendar"></i>
                                                                                <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandler} />

                                                                            </span>
                                                                        </div>

                                                                       {this.state.entry_date != 'Select Date' ? <div className="priceTagalt ">{(getGaragePriceRes.payable_amount != 'N/A') ? "$" + getGaragePriceRes.payable_amount : getGaragePriceRes.payable_amount}<br /><small className='text-dark' >(Amount Due)</small></div> : ''}
                                                                    </div>

                                                                    </>
                                                                        // <tr>
                                                                        //     <td className="td1">
                                                                        //         <b className="radioLink">
                                                                        //             {/* <input type="radio" onChange={() => this.handleDayPlanChange(getGaragePriceRes.price)} name="pass" /> */}
                                                                        //             <label className="radio-label">1 Day Parking</label>
                                                                        //         </b>
                                                                        //         <span>Parking Date pp</span>
                                                                        //         <span className="datePicker datepic-small">
                                                                        //             <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandler} />
                                                                        //             <i className="fa listBlockWrap fa-calendar"></i>
                                                                        //         </span>
                                                                        //     </td>
                                                                        //     <th className="th1">{(getGaragePriceRes.price != 'N/A') ? "$" + getGaragePriceRes.price : getGaragePriceRes.price}</th>
                                                                        // </tr>
                                                                    ) : ''}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>}

                                                {(this.state.pass_rate_id) &&
                                                    <div className="box-2 card-body border-top d-none">
                                                        <div className="row">
                                                            <div className="col-sm-12 col-md-auto mt-2 checkbox">
                                                                <p className="mb-0">
                                                                    <input type="checkbox" id="parkalso" onChange={(e) => this.handleDayBookingWithParking(e , true)} name="1day" />
                                                                    <label className="radio-label" for="parkalso">Book Parking Also</label>
                                                                </p>
                                                            </div>
                                                            <div className="col-sm-12 col-md my-2">
                                                                <p>
                                                                    <span>Parking Date</span>
                                                                    <span className="datePicker datepic-small">
                                                                        <Datetime inputProps={{ readOnly: true }} isValidDate={disablePastDt} closeOnSelect={true} dateFormat={"MM/DD/yyyy"} timeFormat={false} initialValue={this.state.entry_date} value={this.state.entry_date} onChange={this.oneDayDateChangeHandler} />
                                                                        <i className="fa listBlockWrap fa-calendar"></i>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div></div>}



                                            </div>

                                            {/* third CARD DETAILS*/}
                                            {/* TEMPORARY HIDING CARD DETAILS FOR STOPING RESERVATIONS ON 10TH and 11TH AUGUST AS
                                            PER REQUIREMENT IN LIVE FOR CLIENT */}
                                            {this.state.entry_date == '08/10/2024' || this.state.entry_date == '08/11/2024' ? <div className="card oneDayParking">
                                                <div className="box-2 card-body border-top">
                                                    <div className='row'>
                                                        <div className='col-12 fw-bold text-danger d-flex justify-content-center'>
                                                            <h4 className='fw-bold'>Parking is free....no need to make a reservation!</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                                : <div className="card oneDayParking">


                                                <div className="box-2 card-body border-top">

                                                    {/* CARD DETAILS */}

                                                    <div className="row ">
                                                        <div className=' d-flex '><label className="mb-3"><b>Payment Details</b></label></div>

                                                        <div className='col-12 col-md-6 col-sm-8'>
                                                            <div className='row'>
                                                                <div className="col-12 mb-3">
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        id="name"
                                                                        className="form-control"
                                                                        placeholder="Name on the Card"
                                                                        pattern="^([A-Za-z]+[,.]?[ ]?|[A-Za-z]+['-]?)+$"
                                                                        required
                                                                        onInvalid={e => e.target.setCustomValidity('Please enter your name')}
                                                                        onInput={e => e.target.setCustomValidity('')}
                                                                        onChange={(e) => this.handleInputChange(e)} />
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 mb-3">
                                                            <MaskedInput
                                                                maskGenerator={this.maskGenerator}
                                                                value={this.state.card_pan}
                                                                type="text"
                                                                name="card_pan"
                                                                id="card_pan"
                                                                required={true}
                                                                pattern="[0-9 ]{18,19}"
                                                                maxLength='19'
                                                                minLength='18'
                                                                title="Card no. should be 15-16 digit numberic"
                                                                className="form-control"
                                                                onChange={(e) => this.handleCardInputChange(e)}
                                                                onInvalid={e => e.target.setCustomValidity('Please enter a valid card number')}
                                                                onInput={e => e.target.setCustomValidity('')}
                                                                placeholder="Card Number"
                                                            />

                                                        </div>
                                                        <div className="col-sm-6 ">
                                                            <div className="input-group mb-3">
                                                                <input
                                                                    type={this.state.inputType}
                                                                    className="form-control"
                                                                    id='card_card_security_cvx_2'
                                                                    required={true}
                                                                    maxLength='4'
                                                                    minLength='3'
                                                                    // size='4' 
                                                                    inputMode='numeric'
                                                                    name='card_card_security_cvx_2'
                                                                    placeholder="CVV"
                                                                    onChange={(e) => this.handleInputChange(e)}
                                                                    onInvalid={e => e.target.setCustomValidity('Please enter CVV code')}
                                                                    onInput={e => e.target.setCustomValidity('')}
                                                                    onKeyPress={(e) => restrictInputValues(e)}
                                                                    autoComplete="new-password" />
                                                                <span className="cursor input-group-text" id="basic-addon1" onClick={(e) => this.handleCVVVisibility(e, this.state.inputType)}><FontAwesomeIcon icon={this.state.eyeIcon} /></span>
                                                            </div>

                                                        </div>
                                                        <div className="col-sm-6 col-md-6">
                                                            <div className="mb-3">
                                                                <MaskedInput
                                                                    maskGenerator={expirymask}
                                                                    value={expiry}
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    name="expiration_date"
                                                                    id="expiration_date"
                                                                    required={true}
                                                                    pattern="[0-9 ]{4}"
                                                                    maxLength='5'
                                                                    minLength='4'
                                                                    title="Enter a valid expiry date"
                                                                    className="form-control"
                                                                    onChange={this.handleExpiryChange}
                                                                    onInvalid={e => e.target.setCustomValidity('Please enter card expiry date')}
                                                                    onInput={e => e.target.setCustomValidity('')}
                                                                    placeholder="MM/YY"
                                                                />

                                                                {/* <span className="form-text text-danger h-40">{formError == 'pass' ? !formData?.expiration_date ? 'This field is required' : '' : ''}</span> */}
                                                                {/* <span className="form-text text-danger h-40">{formError == 'pass' ? formData?.expiration_date && (formData?.expiration_date?.length<4 || formData?.expiration_date?.length>5)? 'Enter a valid expiry date ':'' : ''}</span> */}
                                                                {/* <span className='form-text text-danger h-40'>{cardExpiryMessage}</span> */}

                                                            </div> </div>
                                                        <input type='hidden' name='card_date_expiry_month' id='card_date_expiry_month' value={this.state.card_date_expiry_month} />
                                                        <input type='hidden' name='card_date_expiry_year' id='card_date_expiry_year' value={this.state.card_date_expiry_year} />
                                                        {/* <div className="col-sm-3 mb-3">
                                                            <select
                                                                name='card_date_expiry_month'
                                                                id="card_date_expiry_month"
                                                                required={true}
                                                                className="form-select"
                                                                visibility="hidden"
                                                                onInvalid={e => e.target.setCustomValidity('Please select expiry month')}
                                                                onInput={e => e.target.setCustomValidity('')}
                                                                onChange={(e) => this.handleInputChange(e)}
                                                            >
                                                                <option value="">Expiry Month</option>
                                                                {EXPIRY_MONTHS.map((item, key) => <option key={key} value={item}>{item}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-3 mb-3">
                                                            <select
                                                                name='card_date_expiry_year'
                                                                id='card_date_expiry_year'
                                                                required={true}
                                                                className="form-select"
                                                                onInvalid={e => e.target.setCustomValidity('Please select expiry year')}
                                                                onInput={e => e.target.setCustomValidity('')}
                                                                onChange={(e) => this.handleInputChange(e)}
                                                            >
                                                                <option value="">Expiry Year</option>
                                                                {EXPIRY_YEARS.map((item, key) => <option key={key} value={item.val}>{item.label}</option>)}
                                                            </select>
                                                        </div> */}

                                                        {/* CARD DETAILS */}


                                                    </div>
                                                    <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                                                    <input type='hidden' name='merchant_script_data_1' id='merchant_script_data_1' value={getSessionAttribute('merchant_script_data_1')} />
                                                    <input type='hidden' name='merchant_script_data_2' id='merchant_script_data_2' value={getSessionAttribute('merchant_script_data_2')} />
                                                    <input type='hidden' name='merchant_script_data_3' id='merchant_script_data_3' value={getSessionAttribute('merchant_script_data_3')} />
                                                    <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={getSessionAttribute('guid')} />
                                                    <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={getSessionAttribute('ipgSession')}></input>

                                                    {((getGaragePriceRes && getGaragePriceRes?.price && getGaragePriceRes?.price == 'N/A') || !getSessionAttribute('api_url') || getSessionAttribute('api_url') == '') ? <button type="button" disabled={true} className="btn py-1 my-1 btn-primary w-100">Pay Now</button> : <button type="button" className="btn py-1 my-1 btn-primary w-100" onClick={this.handleFormSubmit}>Pay Now</button>}
                                                    {/* </form> */}
                                                </div>
                                            </div>}

                                        </form>
                                    </div>
                                </div>
                            </div>: <div className="alert-box-danger-wrapper d-flex justify-content-center align-content-center">
                                    <span className="alert-box-danger border rounded align-content-center p-2 m-2">{this.props.errorMessage && !this.props.errorMessage.includes('.php') ? this.props.errorMessage : 'Something went wrong, Please try again!'}</span>
                                </div>}
                        </div>
                        <BottomLogo
                            className="my-2 text-center bg-opacity-10 d-block d-sm-none"
                        />
                    </div>
                </div>
            </Aux>
        )
    }
}

PassComponent.propTypes = {
    errorMessage: PropTypes.string,
    hasError: PropTypes.bool
}

PassComponent.defaulProps = {
    errorMessage: '',
    hasError: false
}

const mapStateToProps = ({ PassesReducer, PartnerReducer }) => {
    const { passes, isFetching, paymentRes, getGaragePriceRes, hasError, errorMessage, userPasses } = PassesReducer;
    const { memberCheck, partnerDetails, eventRes } = PartnerReducer;
    console.log(getGaragePriceRes)
    return {
        passes,
        userPasses,
        isFetching,
        paymentRes,
        getGaragePriceRes,
        hasError,
        hasErrorPartner: PartnerReducer.hasError,
        hasErrorMessage: PartnerReducer.errorMessage,
        errorMessage,
        memberCheck,
        eventRes,
        partnerDetails
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch,
        reqGetPasses: (data) => dispatch(actionCreators.getPasses(data)),
        reqGetUserPasses: (data) => dispatch(actionCreators.getUserPasses(data)),
        reqGetPrice: (data) => dispatch(actionCreators.getGaragePrice(data)),
        reqMakePayment: (data) => dispatch(actionCreators.makePayment(data)),
        checkMemberExistance: (data) => dispatch(actionCreators.checkMemberId(data)),
        eventRequest: (data) => dispatch(actionCreators.logEvent(data)),
        reqGetPartnerDetails: (data) => dispatch(actionCreators.getPartnerDetails(data)),
    }
}

const ConnectedPassComponent = connect(mapStateToProps, mapDispatchToProps)(PassComponent);

const PassComponentWithRecaptcha = (props) => {
    const { getToken } = useRecaptcha();
    return <ConnectedPassComponent {...props} getRecaptchaToken={getToken} />;
}

export default PassComponentWithRecaptcha;